import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mb-15" }
const _hoisted_2 = { class: "d-flex flex-wrap gap-2 mb-7" }
const _hoisted_3 = { class: "text-fprimary m-0" }
const _hoisted_4 = {
  class: "fs-7 badge rounded-circle",
  style: {"background-color":"var(--bs-magenta)"}
}
const _hoisted_5 = {
  key: 0,
  class: "row g-6 g-xl-9 mb-6 mb-xl-9"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormsFisu = _resolveComponent("FormsFisu")!
  const _component_KTFile3 = _resolveComponent("KTFile3")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FormsFisu, { id: _ctx.id }, null, 8, ["id"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.t("documentAsociated")), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.listDocs.length), 1)
    ]),
    (_ctx.listDocs.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDocs, (item, index) => {
            return (_openBlock(), _createBlock(_component_KTFile3, {
              key: `itmf-${index}`,
              "file-title": item.nombre,
              "file-type": "pdf",
              "created-at": "3 days ago",
              file: item.ruta
            }, null, 8, ["file-title", "file"]))
          }), 128))
        ]))
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: `${_ctx.t('notFoundResult')}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getData
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('tryAgain')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["description"])), [
          [_directive_loading, _ctx.loader]
        ])
  ], 64))
}